import React from 'react';

import HorizontalNav6 from '../components/horizontal-navs/HorizontalNav6';
import HowItWorks1 from '../components/how-it-works/HowItWorks1';
import Features2 from '../components/features/Features2';
import Footer2 from '../components/footers/Footer2';

export default function Apps() {
  return (
    <React.Fragment>
      <HorizontalNav6 content={null} />

      <HowItWorks1 content={null} />

      <Features2 content={null} />

      <Footer2 content={null} />
    </React.Fragment>
  );
}

